import React from 'react';
import './App.css';
import './Skills.css';
import fc from './assets/fc.png';
import stanford from './assets/stanford.png';
import codepath from './assets/codepath.png';
import gwc from './assets/gwc.png';
import {Tooltip} from '@material-ui/core';

function Education() {
    return (
        <div className="wrapper"> 
        <div className="workExperience">

            <h1 className="sectionHeading">skills</h1>

            <h2>programming languages</h2>
            <div className="skillPicsWrapper">
            <Tooltip title="C++" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="cpp" > </div>
            </Tooltip>
            
            <Tooltip title="Python" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="python"></div>
            </Tooltip>

            <Tooltip title="Java" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="java"></div>
            </Tooltip>

            <Tooltip title="Swift" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="swift"></div>
            </Tooltip>
            </div>

            <h2>web development</h2>
            <div className="skillPicsWrapper">
            <Tooltip title="HTML" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="html" > </div>
            </Tooltip>
            
            <Tooltip title="CSS" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="css"></div>
            </Tooltip>

            <Tooltip title="JavaScript" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="js"></div>
            </Tooltip>

            <Tooltip title="TypeScript" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="ts"></div>
            </Tooltip>

            <Tooltip title="ReactJS" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="react"></div>
            </Tooltip>

            <Tooltip title="ReduxJS" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="redux"></div>
            </Tooltip>

            </div>
            <h2>tools and services</h2>
            <div className="skillPicsWrapper">
            <Tooltip title="Git" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="git" > </div>
            </Tooltip>
            
            <Tooltip title="Linux" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="linux"></div>
            </Tooltip>

            <Tooltip title="AWS" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="aws"></div>
            </Tooltip>

            <Tooltip title="MongoDB" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="mongodb"></div>
            </Tooltip>

            <Tooltip title="Firebase" enterDelay={275} leaveDelay={200}>
            <div className="skillImg" id="firebase"></div>
            </Tooltip>
            </div>
        </div>
        </div>
    );

}

export default Education;